var videoEl = $('video'),
    playBtn = $('.js-controls')
         

playBtn.on('click', function () {
    var thisVideo = $(this).siblings('video');

    thisVideo.get(0).play();
    playBtn.hide();
  
});

$('.video').on('click', function(){	
	$(this).get(0).pause();
    playBtn.show();
})